import React from 'react';
import { Redirect } from 'react-router';

import { useQuery } from '@apollo/client/react';
import { Loader } from '@opendoor/bricks/core';
import Box from '@opendoor/bricks/core/Box';
import { IAddressInputAddress } from '@opendoor/cinderblocks/growth/AddressInput/AddressInput';

import { publicClient } from '../config/apolloClients';
import { GetReferralDashboardData_organization } from '../graphql/queries/__generated__/GetReferralDashboardData';
import {
  GET_PRODUCT_ELIGIBILITY,
  IGetProductEligibility,
  IGetProductEligibilityVariables,
} from '../graphql/queries/GetProductEligibility';
import trackEvent from '../helpers/trackEvent';
import { ERROR_PAGE_ROUTE } from '../routes/routes';
import { CheckIcon } from './icons/CheckIcon';
import { CrossIcon } from './icons/CrossIcon';

interface IAddressProps {
  address?: IAddressInputAddress;
  organization: GetReferralDashboardData_organization;
}

const CheckProductEligibility: React.FC<IAddressProps> = ({ address, organization }) => {
  const { data, error, loading } = useQuery<
    IGetProductEligibility,
    IGetProductEligibilityVariables
  >(GET_PRODUCT_ELIGIBILITY, {
    skip: !address,
    variables: {
      addressInput: {
        street1: address ? address.street1 : '',
        city: address ? address.city : '',
        state: address ? address.state : '',
        postalCode: address ? address.postal_code : '',
      },
    },
    client: publicClient,
  });

  if (loading) {
    return (
      <Box position="absolute" right="20px" top="18px">
        <Loader padding={'none'} />
      </Box>
    );
  }

  if (error) {
    return <Redirect to={ERROR_PAGE_ROUTE} />;
  }
  if (!data) {
    return <span />;
  }

  const isEligible = data.address.products.homeSell[0].isEligible;
  trackEvent('click', 'product-eligibility', {
    address,
    partnershipType: organization.partnershipType,
    referralUrl: organization.referralUrl,
    isEligible,
  });

  return (
    <Box position="absolute" right="20px" top="18px">
      {isEligible ? <CheckIcon /> : <CrossIcon />}
    </Box>
  );
};

export default CheckProductEligibility;
